export default "__VITE_ASSET__898cedab__"